import React, { useState, useEffect } from "react";
import { createOfficialSentence, updateOfficialSentence, fetchCategories } from "./adminOfficialSentenceService";
import "../../styles/content.css";

const LEVELS = [{ name: "EASY", display: "Easy" }, { name: "MEDIUM", display: "Medium" }, { name: "HARD", display: "Hard" }];

const OfficialSentenceForm = ({ sentence, onSaved, onCancel }) => {
  const isEdit = !!sentence;
  const [form, setForm] = useState({ title: "", description: "", pronunciation: "", phoneticSpelling: "", categoryId: "", level: "" });
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadCategories();
    if (sentence) {
      console.log("[OfficialSentenceForm] Populating form for edit, id:", sentence.id);
      setForm({ title: sentence.title || "", description: sentence.description || "", pronunciation: sentence.pronunciation || "", phoneticSpelling: sentence.phoneticSpelling || "", categoryId: sentence.categoryId || "", level: sentence.level || "" });
    }
  }, [sentence]);

  const loadCategories = async () => {
    console.log("[OfficialSentenceForm] Loading categories for dropdown");
    const res = await fetchCategories();
    if (res.status === 200) {
      const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
      console.log("[OfficialSentenceForm] Categories loaded:", list.length);
      setCategories(list);
    } else { console.error("[OfficialSentenceForm] Categories load failed:", res.status, res.message); }
  };

  const handleChange = (e) => { console.log("[OfficialSentenceForm] Field changed:", e.target.name, "=>", e.target.value); setForm({ ...form, [e.target.name]: e.target.value }); };

  const handleSubmit = async () => {
    if (!form.title || !form.categoryId || !form.level) { console.warn("[OfficialSentenceForm] Validation failed"); alert("Title, Category and Level are required"); return; }
    const payload = { title: form.title, categoryId: Number(form.categoryId), level: form.level, ...(form.description && { description: form.description }), ...(form.pronunciation && { pronunciation: form.pronunciation }), ...(form.phoneticSpelling && { phoneticSpelling: form.phoneticSpelling }) };
    console.log("[OfficialSentenceForm] Submitting", isEdit ? "update" : "create", "payload:", payload);
    setLoading(true);
    const res = isEdit ? await updateOfficialSentence(sentence.id, payload) : await createOfficialSentence(payload);
    if (res.status === 200 || res.status === 201) { console.log("[OfficialSentenceForm] Submit successful:", res.status); onSaved(); }
    else { console.error("[OfficialSentenceForm] Submit failed:", res.status, res.message); alert(res.message || "Operation failed"); }
    setLoading(false);
  };

  return (
    <div className="modal-overlay"><div className="modal-content"><div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
      <h2>{isEdit ? "Edit" : "Create"} Official Sentence</h2>
      <div className="form-group"><label>Sentence / Title *</label><input name="title" placeholder="e.g. Let's get started with today's agenda." value={form.title} onChange={handleChange} /></div>
      <div className="form-group"><label>Description</label><textarea name="description" placeholder="Brief meaning or context..." value={form.description} onChange={handleChange} rows={2} /></div>
      <div className="form-group"><label>Pronunciation (IPA)</label><input name="pronunciation" placeholder="e.g. /lɛts ɡɛt ˈstɑːrtɪd/" value={form.pronunciation} onChange={handleChange} /></div>
      <div className="form-group"><label>Phonetic Spelling</label><input name="phoneticSpelling" placeholder="e.g. lets get star-ted with tuh-dayz" value={form.phoneticSpelling} onChange={handleChange} /></div>
      <div className="form-group"><label>Category *</label>
        <select name="categoryId" value={form.categoryId} onChange={handleChange}><option value="">Select Category</option>
          {categories.map((c) => (<option key={c.id} value={c.id}>{c.icon} {c.title} ({c.categoryName || c.category})</option>))}
        </select></div>
      <div className="form-group"><label>Level *</label>
        <select name="level" value={form.level} onChange={handleChange}><option value="">Select Level</option>
          {LEVELS.map((l) => (<option key={l.name} value={l.name}>{l.display}</option>))}
        </select></div>
      <div className="form-actions"><button onClick={handleSubmit} disabled={loading}>{loading ? "Saving..." : isEdit ? "Update" : "Create"}</button><button onClick={onCancel} disabled={loading}>Cancel</button></div>
    </div></div></div>
  );
};

export default OfficialSentenceForm;
